import { isString } from '@fi-shared/utils/is-string';
import { BillingContactModel } from '../../billing/billing-contact.model';
import { BillingContactType } from '../../billing/billing-contact-type';
import { fiCustomerType } from './customer-type';
import { fiPaymentMethodType } from '../payment-method-type';
import { fiBasicUsageChargeType } from './basic-usage-charge-type';
import { CustomerBillingInvoiceModel } from '../customer-billing-invoice/customer-billing-invoice.model';
import { AddressModel } from '../../utilities/address/address.model';
import { Injector } from '@angular/core';
import { PackageType } from '@fi-app/billing/package-type';
import { IBillingPriceArticleUsageModel } from '@fi-app/customer-billing/customer-billing-customer/customer-billing-customer';

export class CustomerBillingCustomerModel {
    Id = undefined;
    CustomerId = undefined;
    BillingCustomerId = undefined;
    CustomerType = fiCustomerType.Intranet;
    DomainName = undefined;
    Name = undefined;
    BusinessUnitName = undefined;
    TechnicalName = undefined;
    PaymentStatus = undefined;
    PaymentMethodType = fiPaymentMethodType.CreditCard;
    BasicUsageChargeType = fiBasicUsageChargeType.User;
    LowestUnitLevelChargeType = PackageType.Small;
    ContractPeriodLength = undefined;
    ContractPeriod = undefined;
    ContractStartTime = undefined;
    ContractEndTime = undefined;
    ResellerId = undefined;
    DiscountGlobal = 0.0;
    DiscountLocal = 0.0;
    ExtraDiscount = 0.0;
    MinUsersToCharge = undefined;
    MinUnitsToCharge = undefined;
    VATNumber = undefined;
    ChargeVAT = true;
    Currency = undefined;
    BusinessUnitId = undefined;
    Description = undefined;
    IsSystem = false;
    Address: AddressModel;
    Contacts: BillingContactModel[] = [];
    InvoiceInfo: any;
    CreditCardInfo = undefined;
    UsageInformation = undefined;
    CurrentMonthlyInvoice: CustomerBillingInvoiceModel = undefined;
    CurrentOtherInvoice: CustomerBillingInvoiceModel;
    DefaultResellerName = 'Chainformation AB';
    ChildItems = [];
    IsBaseCurrency: boolean;
    Rate;
    ShutOffDate: Date;
    PriceArticleUsages: IBillingPriceArticleUsageModel[] = [];

    constructor(
        data,
        private injector: Injector,
    ) {
        if (data) this.Initialize(data);
    }

    Initialize(data) {
        Object.assign(this, data);
        if (isString(this.ContractStartTime)) this.ContractStartTime = new Date(this.ContractStartTime);

        if (isString(this.ContractEndTime)) this.ContractEndTime = new Date(this.ContractEndTime);

        if (isString(data.ShutOffDate)) this.ShutOffDate = new Date(data.ShutOffDate);

        if (data.CurrentMonthlyInvoice)
            this.CurrentMonthlyInvoice = new CustomerBillingInvoiceModel(data.CurrentMonthlyInvoice);

        if (data.CurrentOtherInvoice)
            this.CurrentOtherInvoice = new CustomerBillingInvoiceModel(data.CurrentOtherInvoice);

        if (!this.Contacts || !this.Contacts.length) {
            const contactToAdd = new BillingContactModel();
            contactToAdd.BillingContactType = BillingContactType.Contact;
            this.Contacts.push(contactToAdd);
        }

        this.ChildItems = data.ChildItems;
    }

    toJSON() {
        let result: { [prop: string]: any } = {};
        for (let x in this) {
            if (x !== 'injector') result[x] = this[x];
        }
        return result;
    }
}
